import React, { useState } from 'react'
import { ToggleProps } from './types'
import resolveProps from '../../../utils/resolveProps'

const config = {
  types: [],
  modifiers: [
    {
      title: 'default',
      isDefault: true
    },
    'inverse',
    'darkest'
  ],
  states: ['attention']
}

const Toggle = (props: ToggleProps) => {
  const {
    id,
    value = '',
    disabled,
    inverse,
    darkest,
    checked = false,
    parentId,
    parentClassName,
    onChange,
    onToggleChange = () => { },
    hasError = false,
    errorMessage = 'Por favor, preencha este campo corretamente.',
    ...rest
  } = props

  const [isChecked, setIsChecked] = useState(!!checked)

  const _input = React.useRef(null)

  const [error, setError] = React.useState({
    message: errorMessage, // erroMessage
    hasError: hasError
  })

  React.useEffect(() => {
    setError({
      message: errorMessage, // erroMessage
      hasError: hasError
    })
  }, [hasError])

  React.useEffect(() => {
    setIsChecked(!!checked)
    _input.current.checked = !!checked
  }, [props.checked])

  React.useEffect(() => {
    onToggleChange(isChecked)
  }, [isChecked])

  React.useEffect(() => {
    setIsChecked(Boolean(value))
  }, [value])

  const handleKeyPress = (e) => {
    if (e.charCode === 32 || e.charCode === 13) {
      handleToggle()
    }
  }

  const handleToggle = (disabled = false) => {
    if (disabled) return
    const status = !isChecked
    setIsChecked(status)
  }
  return (
    <div
      id={props.parentId}
      tabIndex={0}
      onKeyPress={(e) => handleKeyPress(e)}
      className={`${resolveProps(props, config, 'Toggle')} ${
        parentClassName || ''
      }
        ${error.hasError ? 'mdn-Toggle--attentionField' : ''}`}
      onClick={(e) => {handleToggle(disabled)}}
    >
      <div className="mdn-Toggle-list">
        <input
          {...rest}
          id={id}
          className="mdn-Toggle-item mdn-Toggle-item-primary"
          type="checkbox"
          role="checkbox"
          ref={_input}
          onChange={(e) => !!onChange && onChange(e, isChecked)}
          value={value.toString() || isChecked.toString()}
          checked={isChecked}
          disabled={disabled}
        />
        <label className="mdn-Toggle-button" htmlFor={id} />
      </div>
      {!error.hasError ? (
        ''
      ) : (
        <small className="mdn-Input-errorFeedback">{error.message}</small>
      )}
    </div>
  )
}

export default Toggle

